import { createFileRoute } from "@tanstack/react-router"
import { ReveniAuthModal } from "modules/settings/components/integrations/reveni/ReveniAuthModal"

export const Route = createFileRoute("/_base/_auth/settings/integrations/reveni/connect")({
  component: ReveniAuthModal,
})
